/**
 * Constantes du « Motus du jour » (spec games/motus-daily §2/§5, ADR 0011).
 * Le mot du jour fait 6 à 10 lettres ; 6 essais, non configurable.
 */

export const MOTUS_DAILY_MIN_LENGTH = 6 as const;
export const MOTUS_DAILY_MAX_LENGTH = 10 as const;
export const MOTUS_DAILY_MAX_ATTEMPTS = 6 as const;

/** Fuseau de référence du « jour » (le mot tourne à 00h00 heure de Paris). */
export const MOTUS_DAILY_TIMEZONE = 'Europe/Paris' as const;

/** Forme d'une clé de jour `YYYY-MM-DD` (la validité calendaire est vérifiée serveur). */
export const DAY_KEY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
